import React from "react";
import { Tabs } from "antd";
import { WrapperTabs } from "./style";

export default ({ tabs, onChange, defaultCurrent }) => {
  return (
    <WrapperTabs>
      <Tabs
        items={tabs}
        defaultActiveKey={defaultCurrent}
        onChange={onChange}
      />
    </WrapperTabs>
  );
};
